import { __awaiter } from "tslib";
import { AuthState } from '../state/auth.state';
import { CC_API_BASE_URL } from 'app/core/core.module';
import { FetchFeatureFlags } from '../state/auth.actions.js';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export class UserManagementGuard {
    constructor(store, ccBaseUrl) {
        this.store = store;
        this.ccBaseUrl = ccBaseUrl;
    }
    canActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.store.dispatch(new FetchFeatureFlags()).toPromise();
            const userManagementEnabled = this.store.selectSnapshot(AuthState.props.userManagementEnabled);
            if (userManagementEnabled) {
                window.location.href = new URL('/users', this.ccBaseUrl).toString();
                return false;
            }
            return true;
        });
    }
}
UserManagementGuard.ɵfac = function UserManagementGuard_Factory(t) { return new (t || UserManagementGuard)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(CC_API_BASE_URL)); };
UserManagementGuard.ɵprov = i0.ɵɵdefineInjectable({ token: UserManagementGuard, factory: UserManagementGuard.ɵfac, providedIn: 'root' });
//# sourceMappingURL=user-management-guard.service.js.map